// extracted by mini-css-extract-plugin
module.exports = {"Header":"Header_Header__28Xqm","HeaderLogo":"Header_HeaderLogo__3tXDe","HeaderText":"Header_HeaderText__2Rxc8"};